
import React from 'react';
import { Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import API_ROUTES from '../../../../core/constants/api';
import './../Reporting.scss';
import { AiOutlineZoomIn, AiOutlineZoomOut, AiOutlineExpand } from "react-icons/ai";

const QUES_CODE_PREFIX = 'GHG-';

const GHGDataView = ({
	t,
	ghgContentRef,
	company,
	yearFilter,
	page1,
	branchData,
	countryData,
	emissionData
}) => {

	// Zoom functionality
	const zoomIn = () => {
		if (ghgContentRef && ghgContentRef.current) {
			const currentScale = ghgContentRef.current.style.transform ?
				parseFloat(ghgContentRef.current.style.transform.replace('scale(', '').replace(')', '')) : 1;
			const newScale = Math.min(currentScale + 0.05, 1); // Max zoom 100% (scale 1)
			ghgContentRef.current.style.transform = `scale(${newScale})`;
			ghgContentRef.current.style.transformOrigin = 'top';
		}
	};

	const zoomOut = () => {
		if (ghgContentRef && ghgContentRef.current) {
			const currentScale = ghgContentRef.current.style.transform ?
				parseFloat(ghgContentRef.current.style.transform.replace('scale(', '').replace(')', '')) : 1;
			const newScale = Math.max(currentScale - 0.05, 0.5); // Min zoom 30%
			ghgContentRef.current.style.transform = `scale(${newScale})`;
			ghgContentRef.current.style.transformOrigin = 'top';
		}
	};

	const fitScreen = () => {
		if (ghgContentRef && ghgContentRef.current) {
			ghgContentRef.current.style.transform = 'scale(1)';
			ghgContentRef.current.style.transformOrigin = 'top';
		}
	};

	const renderCompanyLogo = () => {
		const logoURL = API_ROUTES.PROFILESETTINGS.GETCOMPANYLOGO.replace(
			"<companyId>",
			company.id
		);
		return (
			<img style={{ maxHeight: '50px' }} src={logoURL} />
		)
	};

	const getValueToDisplay = (data, key) => {
		const d = data[`${QUES_CODE_PREFIX}${key}`];
		if (d) {
			return d.value ? `${d.value} ${d.uom ?? ''}` : <br />;
		} else {
			return <br />;
		}
	};

	const renderType1TableAnswerForCurrentYear = (data, key, colNos) => {
		const d = data[`${QUES_CODE_PREFIX}${key}`];
		if (!d || d?.keyValues?.length === 0) {
			return (
				<tr>
					{/* {
						colNos?.map((colNo, cIndex) => {
							<td key={`page${key}-td-${cIndex}`}><br /></td>
						})
					} */}
					{colNos?.map((colNo, cIndex) => (
					//  FIX: Added implicit return by switching to parentheses (was missing `return`)
					<td key={`page${key}-td-${cIndex}`}><br /></td>
					))}
				</tr>
			)
		}
		const answers = d.keyValues;
		const groupedDataByCell = Object.groupBy(answers, ({ cell }) => cell);
		const rows = Object.keys(groupedDataByCell);
		return (
			<>
				{
					rows?.map((row, rIndex) => {
						return (
							<tr key={`page${key}-Table-row-${rIndex}`}>
								{
									colNos?.map((colNo, cIndex) => {
										if (colNo === '') return <td>{rIndex + 1}</td>;

										const colData = groupedDataByCell[row]?.find(val => val.key === `${QUES_CODE_PREFIX}${key}${colNo}`);
										return (
											<td key={`page${key}-Table-row-${rIndex}-${cIndex}`}>
												{colData?.value ?? ''} {colData?.uom ?? ''}
											</td>
										);
									})
								}
							</tr>
						);
					})
				}
			</>
		)
	};


	const renderGHG1Section = () => {
		const pageData = page1[QUES_CODE_PREFIX + '1'];
		const data = {};
		pageData?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<section id="Section_A" className="Main_Section Section_A ghg-section">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head text-left ghg-section-head-bar">
						<h5>{t('GHGReport.VerificationInventoryQuality.label')}</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<div className="mt-2 mb-5">
							<ul className='ul_disc'>
								<li className='mb-3'>
									<h6 className='mb-1 '>Has this inventory been verified by an accredited third party? (No/Yes)</h6>
									<p>{getValueToDisplay(data, '1b')}</p>
								</li>
								<li className='mb-3'>
									<h6 className='mb-2 '>if yes, fill in verifier contact information below and attach verification statement</h6>

									<Table bordered >
										<thead>
										</thead>
										<tbody style={{ borderTop: "1px solid #ddd !important" }}>
											<tr>
												<td style={{ width: '175px' }} className='ghg-dark-highlight'>Date of verification:</td>
												<td> {getValueToDisplay(data, '1c')}</td>
											</tr>
											<tr>
												<td className='ghg-dark-highlight'>Verifier: </td>
												<td>{getValueToDisplay(data, '1d')}</td>
											</tr>
											<tr>
												<td className='ghg-dark-highlight'>Email: </td>
												<td>{getValueToDisplay(data, '1e')}</td>
											</tr>
											<tr>
												<td className='ghg-dark-highlight'>Phone: </td>
												<td>{getValueToDisplay(data, '1f')}</td>
											</tr>
											<tr>
												<td className='ghg-dark-highlight'>Address: </td>
												<td>{getValueToDisplay(data, '1g')}</td>
											</tr>
										</tbody>
									</Table>

								</li>
							</ul>
						</div >
					</div>
				</div>
			</section>
		)
	};

	const renderGHG2Section = () => {
		const pageData = page1[QUES_CODE_PREFIX + '2'];
		const data = {};
		pageData?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<div className="mt-2 mb-5">
				<ul className='ul_disc'>
					<li className='mb-3'>
						<h6 className='mb-1 '>Have any facilities, operations and/or emissions sources been excluded from this inventory?  If yes, please specify.</h6>
						<p>{getValueToDisplay(data, '2a')}</p>
					</li>
					<li className='mb-3'>
						<h6 className='mb-1 '>Reporting period covered by this inventory</h6>
						<p>{getValueToDisplay(data, '2b')}</p>
					</li>
				</ul>
			</div >
		);
	};

	const renderGHG3Section = () => {
		const pageData = page1[QUES_CODE_PREFIX + '3'];
		const data = {};
		pageData?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>
				<h6 className='mb-3 fw-bold'>ORGANIZATIONAL BOUNDARIES</h6>
				<div className="mt-2 mb-5">
					<ul className='ul_disc'>
						<li>
							<h6 className='mb-2 '>
								Which consolidation approach was chosen (check each consolidation approach for which your company is reporting emissions.) If your company is reporting according to more than one consolidation approach, please complete and attach an additional completed reporting template that provides your company's emissions data following the other consolidation approach(es).
							</h6>
							<Table bordered >
								<thead>
								</thead>
								<tbody>
									<tr className='ghg-dark-highlight'>
										<td>Equity Share</td>
										<td style={{ width: '130px' }}>Financial Control </td>
										<td>Operational Control</td>
									</tr>
									<tr>
										<td><p>{getValueToDisplay(data, '3b')}</p></td>
										<td><p>{getValueToDisplay(data, '3c')}</p></td>
										<td><p>{getValueToDisplay(data, '3d')}</p></td>
									</tr>
								</tbody>
							</Table>
						</li>
					</ul>
				</div>
			</>
		);
	};

	const renderGHG4Section = () => {
		const pageData = page1[QUES_CODE_PREFIX + '4'];
		const data = {};
		pageData?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>
				<h6 className='mb-3 fw-bold'>OPERATIONAL BOUNDARIES </h6>
				<div className="mt-2 mb-5">
					<ul className='ul_disc'>
						<li className='mb-3'>
							<h6 className='mb-1 '>Are Scope 3 emissions included in this inventory? (Yes/No)</h6>
							<p>{getValueToDisplay(data, '4b')}</p>
						</li>
						<li>
							<h6 className='mb-2 '>If yes, which types of activities are included in Scope 3 emissions? </h6>
							<Table bordered >
								<thead>
									<tr className='ghg-dark-highlight'>
										<th>Scope 3 emissions</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Purchased goods and services </td>
										<td className='text-right' style={{ minWidth: '60px' }}>{getValueToDisplay(data, '4c')}</td>
									</tr>
									<tr>
										<td>Capital goods  </td>
										<td className='text-right'>{getValueToDisplay(data, '4d')}</td>
									</tr>
									<tr>
										<td>Fuel- and energy-related activities </td>
										<td className='text-right'>{getValueToDisplay(data, '4e')}</td>
									</tr>
									<tr>
										<td>Upstream transportation and distribution  </td>
										<td className='text-right'>{getValueToDisplay(data, '4f')}</td>
									</tr>
									<tr>
										<td>Waste generated in operations   </td>
										<td className='text-right'>{getValueToDisplay(data, '4g')}</td>
									</tr>
									<tr>
										<td>Business travel   </td>
										<td className='text-right'>{getValueToDisplay(data, '4h')}</td>
									</tr>
									<tr>
										<td>Employee commuting    </td>
										<td className='text-right'>{getValueToDisplay(data, '4i')}</td>
									</tr>
									<tr>
										<td>Upstream leased assets     </td>
										<td className='text-right'>{getValueToDisplay(data, '4j')}</td>
									</tr>
									<tr>
										<td>Downstream transportation and distribution   </td>
										<td className='text-right'>{getValueToDisplay(data, '4k')}</td>
									</tr>
									<tr>
										<td>Processing of sold products   </td>
										<td className='text-right'>{getValueToDisplay(data, '4l')}</td>
									</tr>
									<tr>
										<td>Use of sold products  </td>
										<td className='text-right'>{getValueToDisplay(data, '4m')}</td>
									</tr>
									<tr>
										<td>End-of-life treatment of sold products  </td>
										<td className='text-right'>{getValueToDisplay(data, '4n')}</td>
									</tr>
								</tbody>
							</Table>
						</li>
					</ul>
				</div>
			</>
		)
	};

	const renderGHG5Section = () => {
		const pageData = page1[QUES_CODE_PREFIX + '5'];
		const data = {};
		pageData?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>
				<h6 className='mb-3 fw-bold'>INFORMATION ON EMISSIONS</h6>

				<div className="mt-2 mb-5">
					<ul className='ul_disc'>
						<li>
							<h6 className=''>
								The table below refers to emissions independent of any GHG trades such as sales, purchases, transfers, or banking of allowances
							</h6>
							<Table bordered >
								<thead>
									<tr className='ghg-dark-highlight'>
										<th>EMISSIONS </th>
										<th>TOTAL(tCO2e) </th>
										<th>CO2(mt)</th>
										<th>CH4(mt)</th>
										<th>N2O(mt) </th>
										<th>HFCs(mt) </th>
										<th>PFCs(mt) </th>
										<th>SF6(mt) </th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className='ghg-dark-highlight'>Scope 1</td>
										<td className='text-right'>{emissionData['mtCO2e'] ?? ''}</td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
									</tr>
									<tr>
										<td className='ghg-dark-highlight'>Scope 2 </td>
										<td className='text-right'>{getValueToDisplay(data, '5b')}</td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
									</tr>
									<tr>
										<td className='ghg-dark-highlight'>Scope 3 (OPTIONAL)  </td>
										<td className='text-right'>{getValueToDisplay(data, '5c')}</td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
										<td className='text-right'></td>
									</tr>
								</tbody>
							</Table>
						</li>
						<li>
							<h6 className='mb-1 '>Direct CO2 emissions from Biogenic combustion (tCO2e )</h6>
							{getValueToDisplay(data, '5d')}
						</li>
					</ul>
				</div>

			</>
		)
	};

	const renderGHG6And7Section = () => {
		const data6 = {};
		page1[QUES_CODE_PREFIX + '6']?.keyValues?.forEach(d => {
			data6[d.key] = d;
		});
		const data7 = {};
		page1[QUES_CODE_PREFIX + '7']?.keyValues?.forEach(d => {
			data7[d.key] = d;
		});
		return (
			<>
				<div className="mt-2 mb-5">
					<h6 className='mb-3 fw-bold'>BASE YEAR</h6>

					<ul className='ul_disc'>
						<li>
							<div className='mb-3'>
								<h6 className='mb-1 '>Year chosen as base year</h6>
								{getValueToDisplay(data6, '6a')}
							</div>
						</li>
						<li>
							<div className='mb-3'>
								<h6 className='mb-1 '>Clarification of company-determined policy for making base year emissions recalculations</h6>
								{getValueToDisplay(data6, '6b')}
							</div>
						</li>
						<li>
							<div className='mb-3'>
								<h6 className='mb-1 '>Context for any significant emissions changes that trigger base year emissions recalculations</h6>
								{getValueToDisplay(data6, '6c')}
							</div>
						</li>
						<li>
							<div className='mb-3'>
								<h6 className='mb-1 '>Context for any significant emissions changes that trigger base year emissions recalculations</h6>
								{getValueToDisplay(data6, '6c')}
							</div>
						</li>
						<li>
							<div className='mb-3'>
								<h6 className='mb-1 '>Base year emissions (Company will choose a base year and here the emission values for that year should shown)</h6>
								{getValueToDisplay(data6, '6c')}
							</div>
						</li>
					</ul>

					<div className='ps-4'>
						<Table bordered >
							<thead>
							</thead>
							<tbody>
								<tr className='ghg-dark-highlight'>
									<td>EMISSIONS </td>
									<td>TOTAL(tCO2e) </td>
									<td>CO2(mt)</td>
									<td>CH4(mt)</td>
									<td>N2O(mt) </td>
									<td>HFCs(mt) </td>
									<td>PFCs(mt) </td>
									<td>SF6(mt) </td>
								</tr>
								<tr>
									<td className='ghg-dark-highlight'>Scope 1</td>
									<td>{getValueToDisplay(data7, '7a')}</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td className='ghg-dark-highlight'>Scope 2 </td>
									<td>{getValueToDisplay(data7, '7b')} </td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td className='ghg-dark-highlight'>Scope 3 (OPTIONAL)  </td>
									<td> {getValueToDisplay(data7, '7c')}  </td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</Table>
					</div>
				</div>
			</>
		);
	};

	const renderGHG8Section = () => {
		const data = {};
		page1[QUES_CODE_PREFIX + '8']?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>
				<div className="mt-2 mb-5">
					<h6 className='fw-bold mb-3'>METHODOLOGIES AND EMISSION FACTORS</h6>

					<ul className='ul_disc'>
						<li>
							<h6 className='mb-1 '>Methodologies used to calculate or measure emissions other than those provided by the GHG Protocol. (Provide a reference or link to any non-GHG Protocol calculation tools used)  </h6>
							{getValueToDisplay(data, '8a')}
						</li>
					</ul>

				</div>
			</>
		);
	};

	const renderGHG9Section = () => {
		const data = {};
		page1[QUES_CODE_PREFIX + '9']?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>
				<div className="mt-2 mb-4">
					<h6 className='fw-bold mb-3'>ORGANIZATIONAL BOUNDARIES   </h6>
					<Table bordered >
						<thead>
							<tr className='ghg-dark-highlight'>
								<th>List of all legal entities or facilities over which reporting company has equity share, financial control or operational control </th>
								<th>% equity share in legal entity</th>
								<th>Does reporting company have financial control? (yes/no) </th>
								<th>Does reporting company have operational control? (yes/no)</th>
							</tr>
						</thead>
						<tbody>
							{renderType1TableAnswerForCurrentYear(page1, '9', ['a', 'b', 'c', 'd'])}
						</tbody>
					</Table>
				</div>
				<div className="mt-2 mb-5">
					<ul className='ul_disc'>
						<li>
							<h6 className=' mb-1'>If the reporting company's parent company does not report emissions, include an organizational diagram that clearly defines relationship of the reporting subsidiary as well as other subsidiaries </h6>
							<p>There is requirement for the company to load a diagram which needs to come in the reports</p>
						</li>
					</ul>
				</div>
			</>
		)
	};

	const renderGHG10Section = () => {
		const data = {};
		page1[QUES_CODE_PREFIX + '10']?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<>

				<h6 className='fw-bold mb-3'>INFORMATION ON EMISSIONS </h6>
				<ul className='ul_disc01 mb-0 specific-list'>
					<li>
						<h6 className=' mb-2'>Emissions disaggregated by source types </h6>
						<Table bordered >
							<tbody>

								<tr className='ghg-dark-highlight'>
									<td colSpan={2}> Scope 1: Direct Emissions from Owned/Controlled Operations  </td>
								</tr>
								<tr>
									<td> a. Direct Emissions from Stationary Combustion   </td>
									<td className='text-right' style={{ minWidth: '60px' }}>{getValueToDisplay(data, '10a')} </td>
								</tr>
								<tr>
									<td> b. Direct Emissions from Mobile Combustion   </td>
									<td className='text-right'>{getValueToDisplay(data, '10b')} </td>
								</tr>
								<tr>
									<td> c. Direct Emissions from Process Sources    </td>
									<td className='text-right'>{getValueToDisplay(data, '10c')} </td>
								</tr>
								<tr>
									<td> d. Direct Emissions from Fugitive Sources     </td>
									<td className='text-right'>{getValueToDisplay(data, '10d')} </td>
								</tr>
								<tr>
									<td> e. Direct Emissions from Agricultural Sources      </td>
									<td className='text-right'>{getValueToDisplay(data, '10e')} </td>
								</tr>
							</tbody>
						</Table>
						<Table bordered >
							<tbody>
								<tr className='ghg-dark-highlight'>
									<td colSpan={2}>Scope 2: Indirect Emissions from the Use of Purchased Electricity, Steam, Heating and Cooling </td>
								</tr>
								<tr>
									<td> a. Indirect Emissions from Purchased/Acquired Electricity   </td>
									<td className='text-right' style={{ minWidth: '60px' }}>{getValueToDisplay(data, '10f')} </td>
								</tr>
								<tr>
									<td> b. Indirect Emissions from Purchased/Acquired Steam    </td>
									<td className='text-right'>{getValueToDisplay(data, '10g')} </td>
								</tr>
								<tr>
									<td> c. Indirect Emissions from Purchased/Acquired Heating    </td>
									<td className='text-right'>{getValueToDisplay(data, '10h')} </td>
								</tr>
								<tr>
									<td> d. Indirect Emissions from Purchased/Acquired Cooling     </td>
									<td className='text-right'>{getValueToDisplay(data, '10i')}</td>
								</tr>
							</tbody>
						</Table>

					</li>
					<li>
						{renderBranchBasedData()}
					</li>
					<li>
						{renderCountryBasedData()}
					</li>
					<li>
						<h6 className='mb-1 '>
							Emissions attributable to own generation of electricity, heat, or stem that is sold or transferred to another organization
						</h6>
						{getValueToDisplay(data, '')}
					</li>
					<li>
						<h6 className='mb-1 '>
							Emissions attributable to the generation of electricity, heat or steam that is purchased for re-sale to non-end users
						</h6>
						{getValueToDisplay(data, '')}
					</li>
					<li>
						<h6 className='mb-1 '>
							Emissions from GHGs not covered by the Kyoto Protocol (e.g., CFCs, NOx,)
						</h6>
						{getValueToDisplay(data, '')}
					</li>

				</ul>


			</>
		)
	};

	const renderGHG11And12Section = () => {
		const data11 = {};
		page1[QUES_CODE_PREFIX + '11']?.keyValues?.forEach(d => {
			data11[d.key] = d;
		});
		const data12 = {};
		page1[QUES_CODE_PREFIX + '12']?.keyValues?.forEach(d => {
			data12[d.key] = d;
		});
		return (
			<>
				<ul className='ul_disc01'>
					<li>
						<h6 className='mb-1 '>
							Information on the causes of emissions changes that did not trigger a base year emissions recalculation (e.g., process changes, efficiency improvements, plant closures)
						</h6>
						{getValueToDisplay(data11, '11a')}
					</li>
					<li>
						<h6 className='mb-1 '>
							GHG emissions data for all years between the base year and the reporting year (including details of and reasons for recalculations, if appropriate)
						</h6>
						<p>{getValueToDisplay(data11, '11b')}</p>
					</li>
					<li>
						<h6 className='mb-1 '>
							Relevant ratio performance indicators (e.g. emissions per kilowatt-hour generated, sales, etc.)
						</h6>
						<p>
							{getValueToDisplay(data12, '12a')}
						</p>
					</li>
					<li>
						<h6 className='mb-1 '>
							An outline of any GHG management/reduction programs or strategies
						</h6>
						<p>
							{getValueToDisplay(data12, '12b')}
						</p>
					</li>

				</ul>

				<div className="mt-2 mb-4">
					<h6 className='fw-bold'>ADDITIONAL INFORMATION </h6>


					<div className='mt-3'>
						<ul className='ul_disc specific-list'>
							<li>
								<h6 className='mb-1 '>
									Information on any contractual provisions addressing GHG-related risks and obligations
								</h6>
								<p>{getValueToDisplay(data12, '12c')}</p>
							</li>
							<li>
								<h6 className='mb-1 '>
									An outline of any external assurance provided and a copy of any verification statement, if applicable, of the reported emissions data.
								</h6>
								<p>{getValueToDisplay(data12, '12d')}</p>
							</li>
							<li>
								<h6 className='mb-1 '>
									Information on the quality of the inventory (e.g., information on the causes and magnitude of uncertainties in emission estimates) and an outline of policies in place to improve inventory quality
								</h6>
								<p>{getValueToDisplay(data12, '12e')}</p>
							</li>
							<li>
								<h6 className='mb-1 '>
									Information on any GHG sequestration
								</h6>
								<p>{getValueToDisplay(data12, '12f')}</p>
							</li>
						</ul>

					</div>
				</div>

			</>
		);
	};

	const renderGHG13Section = () => {

		const data = {};
		page1[QUES_CODE_PREFIX + '13']?.keyValues?.forEach(d => {
			data[d.key] = d;
		});
		return (
			<div className="ETA_card_Section_sub">
				<h6 className='mt-2 mb-3 fw-bold'>INFORMATION ON OFFSETS   </h6>

				<div className="mt-2 mb-4">
					<ul className='ul_disc'>
						<li>
							<h6 className='mb-2 '>
								Information on offsets that have been purchased or developed outside the inventory boundary
							</h6>
							<Table bordered >
								<thead>
									<tr className='ghg-dark-highlight'>
										<th>Quantity of GHGs (tCO2e) </th>
										<th>Type of offset project </th>
										<th>Were the offsets verified/certified and/or approved by an external GHG program (e.g., CDM) </th>
									</tr>
								</thead>
								<tbody>
									{renderType1TableAnswerForCurrentYear(page1, '13', ['a', 'b', 'c'])}
								</tbody>
							</Table>
						</li>
						<li>
							<h6 className='mb-2 '>
								Information on reductions inside the inventory boundary that have been sold/transferred as offsets to a third party.
							</h6>
							<Table bordered >
								<thead>
									<tr className='ghg-dark-highlight'>
										<th>Quantity of GHGs (tCO2e) </th>
										<th>Type of offset project </th>
										<th>Were the offsets verified/certified and/or approved by an external GHG program (e.g., CDM) </th>
									</tr>
								</thead>
								<tbody>
									{renderType1TableAnswerForCurrentYear(page1, '13', ['d', 'e', 'f'])}
								</tbody>
							</Table>
						</li>
					</ul>

				</div>
			</div>
		);
	};

	const renderBranchBasedData = () => {
		return (
			<>
				<h6 className=' '>If emission in mtCO2-e for any entity is greater that 10,000 then show those entities in table below with their emission values </h6>
				<div className="mt-2 mb-4">
					<Table bordered >
						<thead>
						</thead>
						<tbody>
							<tr className='ghg-dark-highlight'><td colSpan='2'>Emissions disaggregated by facility (recommended for individual facilities with stationary combustion emissions over 10,000 mtCO2e) </td></tr>
							<tr>
								<td>Facility   </td>
								<td>Scope 1 emissions </td>
							</tr>
							{
								Object.keys(branchData)?.map((key, index) => {
									return (
										<tr key={`branchData-${index}`}>
											<td>{key}</td>
											<td>{branchData[key]}</td>
										</tr>
									)
								})
							}
						</tbody>
					</Table>
				</div>
			</>
		)
	};

	const renderCountryBasedData = () => {
		return (
			<>
				<h6 className=''>Provide country wise breakup of emission values </h6>
				<div className="mt-2 mb-4">
					<Table bordered >
						<thead>
							<tr className='ghg-dark-highlight'>
								<th colSpan='4'>Emissions disaggregated by country</th>
							</tr>
							<tr className='ghg-dark-highlight'>
								<th rowSpan='2'>Country</th>
								<th colSpan='3'>Emissions </th>
							</tr>
							<tr className='ghg-dark-highlight'>
								<th>Scope 1</th>
								<th>Scope 2</th>
								<th>Scope 3</th>
							</tr>
						</thead>
						<tbody>
							{
								Object.keys(countryData)?.map((key, index) => {
									return (
										<tr key={`countryData-${index}`}>
											<td>{key}</td>
											<td className='text-right'>{countryData[key]}</td>
											<td className='text-right'><br /></td>
											<td className='text-right'><br /></td>
										</tr>
									)
								})
							}
						</tbody>
					</Table>
				</div>
			</>
		)
	};

	return (
		<>

			<div className="ETA_card_center" style={{ height: 'auto' }}>	
			
				<section className='Main_Section_card' ref={ghgContentRef} >
					<section id="Section_Cover" className="Main_Section GHGSection_cover" style={{ position: 'relative' }} >
						<div className="ETA_card_Section 1 position-relative">
							<div className='GHG_section_head'>
								<h2>Greenhouse Gas Emissions Inventory</h2>
								<h3>{company.legalName}</h3>
								<div className='yearFilter'>
									<span>AY (Annual Year) {yearFilter}</span>
								</div>
								<div className='report-company-logo'>
									{renderCompanyLogo()}
								</div>
							</div>
						</div>
					</section>
					<br clear="all" />
					{renderGHG1Section()}
					<section id="Section_B" className="Main_Section Section_B ghg-section" >
						<div className="ETA_card_Section 1">
							<div className="ETA_card_Section_head text-left ghg-section-head-bar">
								<h5>{t('GHGReport.OrganizationalProfileBoundaries.label')}</h5>
							</div>
							<div className="ETA_card_Section_sub">
								<h6 className="ghg-section-subhead-title mb-3">{t('GHGReport.OrganisationalStructureBoundaries.label')}</h6>
								{renderGHG2Section()}
								{renderGHG3Section()}
								{renderGHG4Section()}
								{renderGHG5Section()}
							</div>
						</div>
					</section>
					<br clear="all" />
					<section id="Section_C" className="Main_Section Section_C ghg-section" >
						<div className="ETA_card_Section 1">
							<div className="ETA_card_Section_head text-left">
								<h5>REQUIRED INFORMATION  </h5>
							</div>
							<div className="ETA_card_Section_sub">
								{renderGHG6And7Section()}
								{renderGHG8Section()}
							</div>
						</div>
					</section>
					<section id="Section_D" className="Main_Section Section_D ghg-section" >
						<div className="ETA_card_Section 1">
							<div className="ETA_card_Section_head text-left ghg-section-head-bar">
								<h5>{t('GHGDataView.section.optionalInformation.label')}</h5>
							</div>
							<div className="ETA_card_Section_sub">
								{renderGHG9Section()}
								{renderGHG10Section()}
								{renderGHG11And12Section()}
							</div>
						</div>
					</section>
					<section id="Section_E" className="Main_Section Section_E ghg-section" >
						<div className="ETA_card_Section 1">
							<div className="ETA_card_Section_head text-left ghg-section-head-bar">
								<h5>{t('GHGDataView.section.optionalInformation.label')}</h5>
							</div>
							{renderGHG13Section()}
						</div>
					</section>

				</section>

				<div className="zoom-controls">
					<ul>
						<li>
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="zoom-in-tooltip">
										Zoom In
									</Tooltip>
								}
							>
								<button onClick={() => zoomIn()}>
									<AiOutlineZoomIn />
								</button>
							</OverlayTrigger>
						</li>
						<li>
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="zoom-out-tooltip">
										Zoom Out
									</Tooltip>
								}
							>
								<button onClick={() => zoomOut()}>
									<AiOutlineZoomOut />
								</button>
							</OverlayTrigger>
						</li>
						<li>
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="fit-screen-tooltip">
										Fit Screen
									</Tooltip>
								}
							>
								<button onClick={() => fitScreen()}>
									<AiOutlineExpand />
								</button>
							</OverlayTrigger>
						</li>
					</ul>

				</div>
			</div>
		</>

	);

}

export default withTranslation()(GHGDataView);
